<template>
  <div class="product-wrap">
    <div class="outer">
      <div class="content">
        <img v-for="item in content" v-lazy="item" :key="item" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    content() {
      const glb = [];
      glb[0] = require(`@/assets/images/products/five_${this.$i18n.locale}.jpg`);
      
      return glb;
    }
  }
};
</script>
<style lang="stylus" scoped>
.product-wrap {
  margin-top: 0em;
  background-color: #f2f2f2;

  .outer {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;

    .content {
      width: 100%;

      img {
        display: block;
        margin: 0 auto;
        width: 80%;
        max-width: 1024px;
      }
    }
  }
}
</style>
